/**
 * EditRequest Component
 * Loads an existing request and allows editing
 */

import { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { useForm } from '../contexts/FormContext'
import { getRequestByToken } from '../services/api'

function EditRequest() {
  const { token } = useParams() // Access token, not requestId
  const navigate = useNavigate()
  const { setFormData, setCurrentStep, setEditMode, setEditingRequestId } = useForm()
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    async function loadRequest() {
      try {
        console.log('Loading request for edit with token:', token)
        const response = await getRequestByToken(token)

        // Load form data
        setFormData(response.data)
        setCurrentStep(1) // Start from step 1 in edit mode
        setEditMode(true)
        setEditingRequestId(response.data.requestId) // Use actual requestId from response

        // Navigate to step 1
        navigate('/step/1')
      } catch (err) {
        console.error('Failed to load request:', err)
        setError(err.message || 'Failed to load request')
        setLoading(false)
      }
    }

    if (token) {
      loadRequest()
    }
  }, [token])

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '1.5rem'
      }}>
        ⏳ Loading request...
      </div>
    )
  }

  if (error) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '1rem',
        padding: '2rem'
      }}>
        <div style={{ fontSize: '3rem' }}>⚠️</div>
        <h2>Error Loading Request</h2>
        <p>{error}</p>
        <button onClick={() => navigate('/')}>Return to Homepage</button>
      </div>
    )
  }

  return null
}

export default EditRequest
